import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { WithTranslation, withTranslation } from 'react-i18next';

interface Props extends WithTranslation {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  subscriberCount: number;
}

const ConfirmSendModal: React.FC<Props> = ({ isOpen, onConfirm, onCancel, subscriberCount, t }) => (
  <Modal isOpen={isOpen} toggle={onCancel}>
    <ModalHeader toggle={onCancel}>{t('subscribingLists.confirmSendTitle')}</ModalHeader>
    <ModalBody>
      {t('subscribingLists.confirmSendMessage', { count: subscriberCount })}
    </ModalBody>
    <ModalFooter>
      <Button color="primary" onClick={onConfirm}>
        {t('common.yes')}
      </Button>
      <Button color="secondary" onClick={onCancel}>
        {t('common.cancel')}
      </Button>
    </ModalFooter>
  </Modal>
);

export default withTranslation()(ConfirmSendModal);
